import * as types from "../constants/actionConstants";

const initialState = [];

// Survey statistics for a specific published versions template id
function statisticsReducer(state = initialState, action) {
    switch(action.type) {
        case types.QUESTIONNAIRE_STATISTICS_GET_SUCCESS:
            return action.list;

        default:
            return state;
    }
}

export default statisticsReducer;
